var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCssIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_62_84)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 90,
    height: 90,
    rx: 20,
    fill: "url(#paint0_linear_62_84)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_62_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.125 17C26.8349 17 26.5567 17.1152 26.3516 17.3204C26.1465 17.5255 26.0312 17.8037 26.0312 18.0938V59.875C26.0312 60.2687 26.2413 60.6275 26.5781 60.8244L47.8363 73.0831C47.9988 73.1771 48.1827 73.2277 48.3705 73.23C48.5582 73.2323 48.7434 73.1862 48.9081 73.0962L71.4 60.7719C71.5726 60.6774 71.7165 60.5382 71.8166 60.3688C71.9167 60.1994 71.9693 60.0061 71.9688 59.8094V18.0938C71.9688 17.8037 71.8535 17.5255 71.6484 17.3204C71.4433 17.1152 71.1651 17 70.875 17H27.125ZM19.4688 18.0938C19.4688 13.8675 22.8987 10.4375 27.125 10.4375H70.875C75.1013 10.4375 78.5312 13.8675 78.5312 18.0938V59.8137C78.5307 61.1862 78.1613 62.5332 77.4617 63.7139C76.762 64.8945 75.7579 65.8655 74.5544 66.525L52.0625 78.8537C50.909 79.4851 49.6122 79.8088 48.2973 79.7934C46.9823 79.7781 45.6935 79.4243 44.555 78.7663L23.3012 66.5075C22.1362 65.8359 21.1687 64.8693 20.4959 63.705C19.8231 62.5407 19.4688 61.2197 19.4688 59.875V18.0938ZM35.875 29.0312C35.875 28.161 36.2207 27.3264 36.8361 26.7111C37.4514 26.0957 38.286 25.75 39.1562 25.75H59.3469C60.2171 25.75 61.0517 26.0957 61.6671 26.7111C62.2824 27.3264 62.6281 28.161 62.6281 29.0312V55.7012C62.6285 56.3105 62.4593 56.9078 62.1394 57.4263C61.8195 57.9448 61.3615 58.3639 60.8169 58.6369L50.7194 63.6856C50.2642 63.9129 49.7625 64.0311 49.2537 64.0311C48.745 64.0311 48.2433 63.9129 47.7881 63.6856L37.6906 58.6369C37.1458 58.3649 36.6874 57.9466 36.3668 57.429C36.0461 56.9113 35.8758 56.3146 35.875 55.7056V53.1769C35.875 52.3066 36.2207 51.472 36.8361 50.8567C37.4514 50.2413 38.286 49.8956 39.1562 49.8956C40.0265 49.8956 40.8611 50.2413 41.4764 50.8567C42.0918 51.472 42.4375 52.3066 42.4375 53.1769V53.6756L49.2537 57.0794L56.0656 53.6756V46.365H44.625C43.7548 46.365 42.9202 46.0193 42.3048 45.4039C41.6895 44.7886 41.3438 43.954 41.3438 43.0837C41.3438 42.2135 41.6895 41.3789 42.3048 40.7636C42.9202 40.1482 43.7548 39.8025 44.625 39.8025H56.0656V32.3125H39.1562C38.286 32.3125 37.4514 31.9668 36.8361 31.3514C36.2207 30.7361 35.875 29.9015 35.875 29.0312Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_62_84",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_62_84"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_62_84",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_62_84",
    x: 10,
    y: 10,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_62_84"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_62_84",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_84",
    x1: 49,
    y1: 0,
    x2: 49,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1474F6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssIcon);
export default __webpack_public_path__ + "static/media/css_icon.5d0078b53fdda2e46bf6e8b919b6f062.svg";
export { ForwardRef as ReactComponent };